// src/components/EnemyModal.js
import React, { useEffect, useState } from 'react';
import { colors } from '../styles/colors';

const EnemyModal = ({ enemy, onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!!enemy);
  }, [enemy]);

  if (!enemy) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? 'auto' : 'none',
        transition: 'opacity 0.3s ease',
        zIndex: 1000,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: colors.backgroundPage,
          color: colors.text,
          padding: '2rem',
          borderRadius: '12px',
          maxWidth: '400px',
          width: '90%',
          boxShadow: '0 12px 30px rgba(0,0,0,0.25)',
          transform: visible ? 'scale(1)' : 'scale(0.8)',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        }}
      >
        <h2 style={{ marginTop: 0, color: colors.primary }}>
          👾 {enemy.name} ({enemy.type})
        </h2>
        <p style={{ fontSize: '0.95rem', color: colors.textLight }}>
          <strong>First Appearance:</strong> {enemy.first_appearance || 'Unknown'}
        </p>

        <button
          onClick={onClose}
          style={{
            marginTop: '1.5rem',
            padding: '0.6rem 1rem',
            backgroundColor: colors.button,
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'background-color 0.2s, transform 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = colors.buttonHover;
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = colors.button;
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default EnemyModal;